<template>
  <div>
    <div class="studyway animate__animated animate__fadeIn">
        <div class="main">
            <div @click="link(data, index)" class="box animate__animated animate__rollIn" :style="'animation-delay:' + (index*0.3 + 0.5) + 's'" v-for="(data, index) in list" :key="data.id">
                <img class="studywayIconImg" :src='"../../../assets/images/student/studywayIcon" + (index%8+1) + ".png"' alt="">
                <div class="text">{{ data.mc }}</div>
            </div>
        </div>
    </div>
    <mainHeader :header_data="[{ title: '学习之旅' }]"/>
    <Footer :flag="false"/>
  </div>
</template>

<script>
import mainHeader from "@/components/student/header";
import { wordType, isHaveBb, getPmzt } from '@/api/student'
export default {
  components: {
      mainHeader,
      Footer:(resolve) => {
        require(['@/components/student/footer.vue'],resolve)
      }
  },
  data() {
    return {
        list: [],
        isCheck: 0, // 除了自然拼读，是否可以进去 0不可以1可以
    }
  },
  created() {
    // 登录时判断当前屏幕状态, 0锁屏,1正常访问
      getPmzt({
        bjid: JSON.parse(sessionStorage.getItem('jxInfo')).bjid
      }).then(a => {
        if (!a.result) {
            this.$lock('on')
        } else {
            this.$lock('off')
        }
      }),
      wordType({ bjid: JSON.parse(sessionStorage.getItem('jxInfo')).bjid, jxid: JSON.parse(sessionStorage.getItem('jxInfo')).jxid, xsid: this.$store.state.userInfo.yhid, yycdid: Number(sessionStorage.getItem('yycdid')) }).then(res => {
          if (res.success) {
            this.isCheck = res.result.isCheck
            this.list = res.result.listType
          } else {
            this.$message.error(res.resultDesc)
          }
      })
  },
  methods: {
      back() {
        const main = document.getElementsByClassName('main')[0];
        const studyway = document.getElementsByClassName('studyway')[0];
        main.classList.add('animate__animated', 'animate__fadeOutRight')
        setTimeout(() => {
            studyway.classList.add('animate__animated', 'animate__fadeOut')
            setTimeout(() => {
                this.$router.replace({ name: 'home' })
            }, 600)
        }, 300)
      },
      link(data, index) {
        if (data.mc !== '自然拼读' && data.mc !== '国际通用' && data.mc !== '行业词汇' && data.mc !== '大学词汇' && !this.isCheck) {
          this.$message.warning('请先学习自然拼读')
          return false
        }
        let jxInfo = JSON.parse(sessionStorage.getItem('jxInfo'))
        jxInfo.lxid = data.id
        jxInfo.lxmc = data.mc
        sessionStorage.setItem('jxInfo', JSON.stringify(jxInfo))
        isHaveBb({ bjid: JSON.parse(sessionStorage.getItem('jxInfo')).bjid, lxid: data.id, yycdid: this.$store.state.yycdid }).then(res => {
            if (res.success) {
                if (res.result.length) {
                    sessionStorage.setItem('bbInfo', JSON.stringify(res.result))
                    const box = document.getElementsByClassName('box')
                    for(let i = 0; i < box.length; i++) {
                        if (i !== index) {
                            box[i].style.animationDelay = '0s'
                            box[i].className = 'box'
                            box[i].classList.add('animate__animated', 'animate__fadeOutRight')
                        } else {
                            box[i].style.animationDelay = '0.3s'
                            box[i].className = 'box'
                            box[i].classList.add('animate__animated', 'animate__bounceOut')
                            const studyway = document.getElementsByClassName('studyway')[0];
                            setTimeout(() => {
                                studyway.classList.add('animate__animated', 'animate__fadeOut')
                                setTimeout(() => {
                                    this.$router.replace({ name: 'books', query: { type: data.mc, bbid: res.result[0].bbid,lxid:data.id } })
                                }, 500)
                            }, 800)
                        }
                    }
                } else {
                    this.$message.warning('当前模块暂无版本')
                }
            } else {
                this.$message.error(res.resultDesc)
            }
        })
      }
  },
  mounted(){
    this.$Bus.$on('lock' , msg => {
      if(msg.indexOf('on')){
        // this.$lock('on')
        // 判断是否是教师班级下的学生
        if(msg.includes(JSON.parse(sessionStorage.getItem('userInfo')).yhid)){
          this.$lock('on')
          this.$Bus.$emit('whether', true) // 传给测试页 清除定时器
        }
      } else if(msg.indexOf('off')){
        // this.$lock('off')
        if(msg.includes(JSON.parse(sessionStorage.getItem('userInfo')).yhid)){
          this.$lock('off')
          this.$Bus.$emit('whether', false)
        }
      }
    })
  }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1367px){
    .studyway{
        .main{
            width: 75%!important;
        }
    }
}
@media screen and (max-width: 700px) {
  .studyway {
    .main {
      width: 100% !important;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 20px;
      padding: 0 15px;
      position: absolute;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
      overflow-y: auto;
      max-height: 80vh;
      .box {
        width: calc(33.33% - 20px);
        min-width: 150px;
        text-align: center;
        cursor: pointer;
        position: relative;

        img {
          width: 100%;
          display: block;
        }

        .text {
          position: absolute;
          bottom: 12%;
          left: 50%;
          transform: translateX(-50%);
          font-size: 16px !important;
          font-weight: bold;
          color: #333;
          white-space: nowrap;
          background: rgba(255, 255, 255, 0.7);
          padding: 2px 8px;
          border-radius: 20px;
          z-index: 1;
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .studyway {
    .main {
      gap: 15px;
      position: absolute;
      left: 50%;
      top: 30%;
      .box {
        width: calc(50% - 15px);

        .text {
          font-size: 13px !important;
          bottom: 10%;
          white-space: nowrap;
          padding: 2px 6px;
        }
      }
    }
  }
}

@media screen and (max-width: 380px) {
  .studyway {
    .main {
      position: absolute;
      left: 50%;
      top: 30%;
      .box {
        .text {
          font-size: 11px !important;
          white-space: nowrap;
          padding: 1px 4px;
        }
      }
    }
  }
}
.studyway{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-image: url('../../../assets/images/student/studywayBanner.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .main{
        width: 60%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        .box{
            float: left;
            width: 25%;
            box-sizing: border-box;
            padding: 0px 10px;
            position: relative;
            cursor: pointer;
            img{
                width: 100%;
            }
            .text{
                position: absolute;
                top: 60%;
                left: 50%;
                transform: translateX(-50%);
                text-align: center;
                color: #333;
                font-size: 1.37vw;
                font-weight: bold;
            }
        }
    }
}
</style>




